(function () {
  function selectElement(selector, node) {
    return (node || document).querySelector(selector) || {};
  }

  function getCustomFields() {
    const elements = document.querySelectorAll(".mxpr-custom-field");
    const customFields = {}
    elements.forEach(elm => {
      if (elm.type == "checkbox") {
        if(elm.checked){
          const values = customFields[elm.name]?.value || [];
          values.push(elm.value);
          customFields[elm.name] = { value: values }
        }
      } else {
        customFields[elm.name] = { value: elm.value }
      }
    });
    return customFields;
  }

  async function submitReview(productId, customerId, images = null) {
    const customFields = getCustomFields();
    const fetchOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        review: {
          productId: productId,
          customerId: customerId,
          rating: selectElement("#mxpr-form__rating").value,
          name: selectElement("#mxpr-form__name").value,
          email: selectElement("#mxpr-form__email").value,
          guest: customerId ? false : true,
          title: selectElement("#mxpr-form__title").value,
          body: selectElement("#mxpr-form__body").value,
          images: images,
          customFields: customFields
        },
      }),
    };

    return await fetch("/tools/prime-review/api/postReview", fetchOptions);
  }

  // 入力チェック。エラーの場合は true を返す
  function checkInput() {
    const review = {
      name: selectElement("#mxpr-form__name").value,
      title: selectElement("#mxpr-form__title").value,
      body: selectElement("#mxpr-form__body").value,
    };
    const alerts = document.getElementsByClassName("mxpr-form-alert-message");
    for (let i = 0; i < alerts.length; i++) {
      alerts[i].style.display = "none";
    }
    if (!review.name) {
      document.getElementById("mxpr-form__name-alert").style.display = "block";
    } else if (!review.title) {
      document.getElementById("mxpr-form__title-alert").style.display = "block";
    } else if (!review.body) {
      document.getElementById("mxpr-form__body-alert").style.display = "block";
    } else if (review.body.length < 5) {
      document.getElementById("mxpr-form__body-alert-short").style.display = "block";
    } else if (review.body.length > 4000) {
      document.getElementById("mxpr-form__body-alert-long").style.display = "block";
    } else {
      const elements = document.querySelectorAll(".mxpr-custom-field");
      const customFields = {}
      elements.forEach(elm => {
        if (elm.type == "checkbox") {
          const values = customFields[elm.name]?.value || [];
          if(elm.checked){
            values.push(elm.value);
          }
          customFields[elm.name] = { value: values }
        }
      });
      // console.log("*customFields: ", customFields);
      let existRequireFails = false;
      Object.keys(customFields).forEach(key => {
        const validationElement = document.getElementById(`mxpr-choicelist-${key}`)
        if(validationElement.dataset.required == "true"){
          if(customFields[key].value.length == 0){
            alert(`${validationElement.dataset.validationPrefix}${validationElement.dataset.fieldName}${validationElement.dataset.validationSuffix}`)
            existRequireFails = true;
          }
        }
      });
      if(!existRequireFails){
        return false;
      }
    }

    return true;
  }

  async function getFileUrl(uppyFiles) {
    // console.log("*uppyFiles: ", uppyFiles);
    const imageUrls = [];
    const files = Object.keys(uppyFiles).map(key => {
      const ext = uppyFiles[key].name.split(".").slice(-1)[0];
      const fileName = key.replace(/\W/g, '');
      return {
        name: `${fileName}.${ext}`,
        size: uppyFiles[key].size,
        type: uppyFiles[key].type,
        // prefix: uppyFiles[key].id.replace(/\//g, "_mxpr-sep_") + "_mxpr-image_"
      }
    });
    if (files.length == 0) {
      return { error: false, result: {} };
    }
    const fetchOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        files: files,
      }),
    };

    const createResult = await fetch("/tools/prime-review/api/uploadsCreate", fetchOptions);
    const createResultJson = await createResult.json();
    if (createResultJson.error) {
      return { error: true, result: createResultJson };
    }
    const targets = createResultJson.result.data.stagedUploadsCreate.stagedTargets;
    // console.log("*targets: ", targets);
    for (const target of targets) {
      // keyが id で終わっているdataを送信
      const formData = new FormData();
      target.parameters.forEach(({ name, value }) => {
        formData.append(name, value);
      })
      const param = target.parameters.find(p => p.name == "key");
      const key = param.value.split(".").slice(-2)[0];
      const fileKey = Object.keys(uppyFiles).find(uppyKey => key.endsWith(uppyKey.replace(/\W/g, '')))
      const file = uppyFiles[fileKey];
      // console.log("*file: ", file);
      formData.append("file", file.data);
      const response = await fetch(target.url, {
        method: 'POST',
        body: formData
      });
      // console.log("*response: ", response);
      // console.log("*target.resourceUrl: ", target.resourceUrl);
      if (response.ok) {
        imageUrls.push({ originalUrl: target.resourceUrl, type: file.type.startsWith("image/") ? "IMAGE" : "FILE" });
      } else {
        return { error: true, result: response };
      }
    }
    const createOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        files: imageUrls,
      }),
    };

    const commitResult = await fetch("/tools/prime-review/api/uploadsCommit", createOptions);
    // console.log("*commitResult: ", commitResult);
    const commitResultJson = await commitResult.json();
    // console.log("*commitResultJson: ", commitResultJson);

    return { error: createResultJson.errors?.length > 0, result: commitResultJson, imageUrls: imageUrls };
  }

  function initWriteReview({ target }) {
    const rootBlock = target.closest(".mxpr-block[data-product-id]");
    const { productId, customerId } = rootBlock.dataset;
    if (!customerId) {
      if(!window.PrimeReviewSettings?.reviewAllowGuest){
        if (confirm(target.dataset.alert)) {
          location.href = `/account/login?checkout_url=${window.location.pathname}`;
        }
        return;  
      }
      // メールアドレス入力欄を表示
      const emailArea = document.getElementById("email-field-for-guest");
      if(emailArea){
        emailArea.style.display = "block";
      }
      if(window.PrimeReviewSettings?.emailRequired){
        const emailField = document.getElementById("mxpr-form__email");
        if(emailField){
          emailField.required = "true";
        }
      }
    }
    const el = target.parentNode.classList.contains(
      "mxpr-summary__no-reviews"
    )
      ? target.parentNode
      : target;
    el.parentNode.removeChild(el);

    const form = document.getElementById("mxpr-product-reviews-form");
    const submitButton = document.getElementById("mxpr-form-submit-button");
    form.style.display = "flex";

    submitButton.addEventListener("click", async (event) => {
      event.preventDefault();
      const errorMessage = document.getElementById("mxpr-form-message-error");
      errorMessage.style.display = "none";

      if (checkInput()) {
        return;
      }

      const submitButton = document.getElementById("mxpr-form-submit-button");
      const submitMessage = document.getElementById("mxpr-form-submit-message");
      const submitLoading = document.getElementById("mxpr-form-submit-loading");
      const originalButtonCaption = submitMessage.innerText;
      submitButton.disabled = true;
      submitMessage.innerText = submitButton.dataset.sending;
      submitButton.classList.add("mxpr-form__submit--loading");
      submitLoading.style.display = "block";

      selectElement("#mxpr-form__name").disabled = true;
      selectElement("#mxpr-form__email").disabled = true;
      selectElement("#mxpr-form__title").disabled = true;
      selectElement("#mxpr-form__body").disabled = true;
      selectElement("#mxpr-form__rating").disabled = true;
      const dashboard = uppy.getPlugin('Dashboard');
      dashboard.setOptions({ disabled: true });

      const res = await getFileUrl(uppy.state.files);
      // console.log("*res: ", res);
      if (res.error || res.result.error) {
        const errorMessage = document.getElementById("mxpr-form-message-error");
        errorMessage.style.display = "block";
        submitButton.disabled = false;
        submitMessage.innerText = originalButtonCaption;
        submitLoading.style.display = "none";
        submitButton.classList.remove("mxpr-form__submit--loading");
        return;
      }

      const images = res.result?.result?.data?.fileCreate?.files?.map(file => {
        return { id: file.id, type: file.__typename == "MediaImage" ? "IMAGE" : "FILE" }
      });
      // console.log("*images: ", images);
      const result = await submitReview(productId, customerId, images);

      if (result.status === 200) {
        form.style.display = "none";
        // event.target.parentNode.removeChild(event.target);
        MicroModal.show('mxpr-modal-thankyou');
        // const thankyou = document.getElementById("mxpr-form-message-thankyou");
        // thankyou.style.display = "block";
      } else {
        errorMessage.style.display = "block";
        selectElement("#mxpr-form__name").disabled = false;
        selectElement("#mxpr-form__title").disabled = false;
        selectElement("#mxpr-form__body").disabled = false;
        selectElement("#mxpr-form__rating").disabled = false;
        dashboard.setOptions({ disabled: false });
      }

    });

  }

  function resizeTextarea({ target }) {
    const PADDING_Y = 20;
    const $textarea = document.getElementById("textarea");
    let lineHeight = getComputedStyle(target).lineHeight;
    lineHeight = lineHeight.replace(/[^-\d\.]/g, '') || 24;
    const lines = (target.value + '\n').match(/\n/g).length;
    const height = lineHeight * lines + PADDING_Y;
    if (height > 70) {
      target.style.height = height + 'px';
    }
  }

  document.querySelector(".mxpr-summary__write-review").addEventListener("click", initWriteReview);

  // document.querySelector("#mxpr-form__body").addEventListener("input", resizeTextarea);

  const textareas = document.querySelectorAll(".mxpr-text-area");
  textareas.forEach(textarea => textarea.addEventListener("input", resizeTextarea));

  console.log("[INFO] Prime Review has been launched: version 71");
})();
